import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RequestError } from "./api/client";
import "./index.css";
import { Library } from "./routes/Library";
import { OwnedReplay, SharedReplay } from "./routes/Viewer";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // A refusal is an answer: asking again for a replay that belongs to
      // somebody else only delays saying so.
      retry: (failures, error) =>
        failures < 1 && !(error instanceof RequestError && error.status >= 400 && error.status < 500),
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Library />} />
          <Route path="/replay/:id" element={<OwnedReplay />} />
          <Route path="/r/:token" element={<SharedReplay />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
